export const VISIBILITY_TYPES = [
    { id: 1, name: 'Физ. лица' },
    { id: 2, name: 'Юр. лица' },
    { id: 3, name: 'Все пользователи' },
]
